import { ComparisonOperators } from '@contentsquare/fov-constants';
export const numberVisitsCondition = {
    id: 'number-of-visits',
    category: 'conditions',
    value: {
        operatorValues: [
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_EXACTLY' },
            { value: ComparisonOperators.MATCH_GREATER, label: 'CONDITION_SELECT_MORE_THAN' },
            { value: ComparisonOperators.MATCH_LESS, label: 'CONDITION_SELECT_LESS_THAN' },
        ],
    },
};
//# sourceMappingURL=number-visits-condition.value.js.map